export interface MovieItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  tags: string[];
  updateDate: string;
  featured: boolean;
  content: string;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '动作片', slug: 'action' },
  { name: '喜剧片', slug: 'comedy' },
  { name: '爱情片', slug: 'romance' },
  { name: '科幻片', slug: 'sci-fi' },
  { name: '恐怖片', slug: 'horror' },
  { name: '剧情片', slug: 'drama' },
  { name: '动画片', slug: 'animation' },
  { name: '纪录片', slug: 'documentary' },
  { name: '电视剧', slug: 'tv-series' },
];

export const featuredMovies: MovieItem[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: '科幻片',
    categorySlug: 'sci-fi',
    year: 2026,
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20movie%20scene%20with%20spaceship%20and%20earth%20in%20background%2C%20epic%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20movie%20poster%20style%2C%20high%20contrast%2C%20warm%20orange%20and%20deep%20blue%20tones%2C%20clean%20composition&width=800&height=450&seq=featured-1&orientation=landscape',
    description: '在太阳急速衰老膨胀的未来，人类面临前所未有的生存危机。联合政府集结全球航天力量，开启"流浪地球"计划的第三阶段。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '148分钟',
    tags: ['科幻', '灾难', '冒险'],
    updateDate: '2026-07-28',
    featured: true,
    content: '在太阳急速衰老膨胀的未来，人类面临前所未有的生存危机。联合政府集结全球航天力量，开启"流浪地球"计划的第三阶段。地球发动机全面启动，人类文明在宇宙中漂泊，面临着来自深空未知的威胁。一群勇敢的宇航员踏上了拯救人类命运的终极征程，他们将穿越未知的星系，面对无法想象的挑战...',
  },
  {
    id: 'movie-2',
    title: '长安三万里2',
    category: '动画片',
    categorySlug: 'animation',
    year: 2026,
    rating: 9.0,
    image: 'https://readdy.ai/api/search-image?query=ancient%20Chinese%20Tang%20dynasty%20animated%20movie%20scene%2C%20poetic%20landscape%20with%20mountains%20and%20rivers%2C%20traditional%20Chinese%20art%20style%2C%20warm%20golden%20light%2C%20elegant%20composition%2C%20cultural%20aesthetic&width=800&height=450&seq=featured-2&orientation=landscape',
    description: '大唐盛世，诗人们以笔为剑，书写着属于时代的壮丽诗篇。李白、杜甫等文人墨客的故事再次在大银幕上绽放光彩。',
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    duration: '168分钟',
    tags: ['动画', '历史', '文化'],
    updateDate: '2026-07-25',
    featured: true,
    content: '大唐盛世，诗人们以笔为剑，书写着属于时代的壮丽诗篇。李白、杜甫等文人墨客的故事再次在大银幕上绽放光彩。影片延续第一部的诗意画风，以更加宏大的叙事视角，展现了大唐文化的繁荣与诗人们的精神世界...',
  },
  {
    id: 'movie-3',
    title: '孤注一掷2',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2026,
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=suspenseful%20crime%20drama%20movie%20scene%20with%20dark%20alley%20and%20neon%20lights%2C%20tense%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20red%20and%20cool%20blue%20contrast%2C%20dramatic%20shadows&width=800&height=450&seq=featured-3&orientation=landscape',
    description: '网络诈骗日益猖獗，一群普通人被卷入跨国犯罪集团的漩涡中。正义与邪恶的较量，在暗网深处悄然展开。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅'],
    region: '中国大陆',
    duration: '130分钟',
    tags: ['犯罪', '剧情', '悬疑'],
    updateDate: '2026-07-20',
    featured: true,
    content: '网络诈骗日益猖獗，一群普通人被卷入跨国犯罪集团的漩涡中。正义与邪恶的较量，在暗网深处悄然展开。影片基于真实事件改编，揭示了网络诈骗产业链的惊人内幕，以及普通人在面对巨大诱惑和威胁时的抉择...',
  },
];

export const allMovies: MovieItem[] = [
  ...featuredMovies,
  {
    id: 'movie-4',
    title: '热辣滚烫2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.5,
    image: 'https://readdy.ai/api/search-image?query=warm%20and%20funny%20Chinese%20comedy%20movie%20scene%2C%20bright%20boxing%20gym%20setting%2C%20inspirational%20atmosphere%2C%20warm%20lighting%2C%20uplifting%20mood%2C%20clean%20cinematic%20look&width=800&height=450&seq=movie-4&orientation=landscape',
    description: '乐莹在赢得拳击比赛后，人生迎来了全新篇章。她开了一家拳击馆，用自己的经历激励更多人改变自己。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    region: '中国大陆',
    duration: '129分钟',
    tags: ['喜剧', '运动', '励志'],
    updateDate: '2026-07-18',
    featured: false,
    content: '乐莹在赢得拳击比赛后，人生迎来了全新篇章。她开了一家拳击馆，用自己的经历激励更多人改变自己。然而创业之路并非一帆风顺，面对经营困难、人际关系和新的挑战，乐莹需要再次证明自己的勇气和决心...',
  },
  {
    id: 'movie-5',
    title: '封神第三部',
    category: '动作片',
    categorySlug: 'action',
    year: 2026,
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20mythology%20fantasy%20movie%20battle%20scene%2C%20ancient%20Chinese%20warriors%20with%20armor%2C%20dramatic%20sky%20with%20divine%20light%2C%20cinematic%20grandeur%2C%20warm%20golden%20and%20crimson%20tones&width=800&height=450&seq=movie-5&orientation=landscape',
    description: '封神大战进入最终阶段。姜子牙率领西周大军与商朝展开惊天动地的最终对决，诸神之战一触即发。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    region: '中国大陆',
    duration: '155分钟',
    tags: ['动作', '奇幻', '古装'],
    updateDate: '2026-07-15',
    featured: false,
    content: '封神大战进入最终阶段。姜子牙率领西周大军与商朝展开惊天动地的最终对决，诸神之战一触即发。天命所归，封神榜上的名字一个个被点亮，一场改变天地格局的史诗之战即将落下帷幕...',
  },
  {
    id: 'movie-6',
    title: '深海2',
    category: '动画片',
    categorySlug: 'animation',
    year: 2026,
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20underwater%20animated%20fantasy%20movie%20scene%2C%20colorful%20coral%20reef%20and%20mysterious%20deep%20ocean%2C%20dreamlike%20atmosphere%2C%20vibrant%20bioluminescent%20colors%2C%20magical%20lighting&width=800&height=450&seq=movie-6&orientation=landscape',
    description: '参宿在深海的冒险之后，获得了面对现实的勇气。这一次，她将重返深海世界，揭开更多关于"深海大饭店"的秘密。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文', '滕奎兴'],
    region: '中国大陆',
    duration: '112分钟',
    tags: ['动画', '奇幻', '冒险'],
    updateDate: '2026-07-10',
    featured: false,
    content: '参宿在深海的冒险之后，获得了面对现实的勇气。这一次，她将重返深海世界，揭开更多关于"深海大饭店"的秘密。深海中的奇幻生物和神秘力量，将引领她走向一个更加宏大的冒险...',
  },
  {
    id: 'movie-7',
    title: '人生大事2',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2026,
    rating: 8.7,
    image: 'https://readdy.ai/api/search-image?query=touching%20Chinese%20family%20drama%20movie%20scene%2C%20warm%20neighborhood%20setting%20at%20sunset%2C%20emotional%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20gentle%20and%20heartwarming%20composition&width=800&height=450&seq=movie-7&orientation=landscape',
    description: '莫三妹在殡葬行业继续前行，面对生死，她学会了更加深刻地理解人生的意义。',
    director: '刘江江',
    actors: ['朱一龙', '杨恩又', '王戈'],
    region: '中国大陆',
    duration: '125分钟',
    tags: ['剧情', '家庭', '温情'],
    updateDate: '2026-07-05',
    featured: false,
    content: '莫三妹在殡葬行业继续前行，面对生死，她学会了更加深刻地理解人生的意义。当一位特殊的客户来到她的殡葬店，一段关于生命、爱与传承的故事悄然展开...',
  },
  {
    id: 'movie-8',
    title: '满江红2',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2026,
    rating: 8.6,
    image: 'https://readdy.ai/api/search-image?query=historical%20Chinese%20dynasty%20suspense%20movie%20scene%2C%20ancient%20courtyard%20with%20red%20lanterns%2C%20mysterious%20atmosphere%2C%20dim%20dramatic%20lighting%2C%20traditional%20Chinese%20architecture&width=800&height=450&seq=movie-8&orientation=landscape',
    description: '南宋绍兴年间，一场围绕岳飞遗言的新阴谋在临安城中悄然酝酿。忠义与背叛，再次上演。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译'],
    region: '中国大陆',
    duration: '142分钟',
    tags: ['剧情', '悬疑', '古装'],
    updateDate: '2026-06-28',
    featured: false,
    content: '南宋绍兴年间，一场围绕岳飞遗言的新阴谋在临安城中悄然酝酿。忠义与背叛，再次上演。各方势力在暗处博弈，一场关乎大宋命运的棋局正在展开...',
  },
  {
    id: 'movie-9',
    title: '奔跑吧2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=energetic%20Chinese%20sports%20comedy%20movie%20scene%2C%20marathon%20race%20with%20colorful%20participants%2C%20sunny%20day%2C%20joyful%20and%20dynamic%20atmosphere%2C%20bright%20and%20vibrant%20colors&width=800&height=450&seq=movie-9&orientation=landscape',
    description: '一群马拉松爱好者再次集结，参加全国马拉松大赛。欢笑与泪水交织的赛道上，每个人都在奔跑中找到了自己。',
    director: '大鹏',
    actors: ['大鹏', '白客', '庄达菲'],
    region: '中国大陆',
    duration: '115分钟',
    tags: ['喜剧', '运动', '励志'],
    updateDate: '2026-06-20',
    featured: false,
    content: '一群马拉松爱好者再次集结，参加全国马拉松大赛。欢笑与泪水交织的赛道上，每个人都在奔跑中找到了自己。从训练到比赛，他们经历了无数搞笑又感人的瞬间...',
  },
  {
    id: 'movie-10',
    title: '异人之下2',
    category: '动作片',
    categorySlug: 'action',
    year: 2026,
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=modern%20Chinese%20supernatural%20action%20movie%20scene%2C%20urban%20setting%20with%20mystical%20energy%20effects%2C%20dynamic%20fight%20choreography%2C%20cool%20neon%20and%20natural%20light%20blend&width=800&height=450&seq=movie-10&orientation=landscape',
    description: '异人世界的秘密逐渐浮出水面，张楚岚与冯宝宝踏上新的冒险旅程，面对更强大的对手。',
    director: '乌尔善',
    actors: ['胡先煦', '李宛妲', '冯绍峰'],
    region: '中国大陆',
    duration: '138分钟',
    tags: ['动作', '奇幻', '冒险'],
    updateDate: '2026-06-15',
    featured: false,
    content: '异人世界的秘密逐渐浮出水面，张楚岚与冯宝宝踏上新的冒险旅程，面对更强大的对手。古老传承与现代都市的碰撞，一场关乎异人世界命运的大战即将爆发...',
  },
  {
    id: 'movie-11',
    title: '狂飙：电影版',
    category: '剧情片',
    categorySlug: 'drama',
    year: 2026,
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=dark%20Chinese%20crime%20thriller%20movie%20scene%2C%20police%20investigation%20with%20rainy%20night%20cityscape%2C%20tense%20atmosphere%2C%20film%20noir%20style%2C%20moody%20blue%20and%20amber%20lighting&width=800&height=450&seq=movie-11&orientation=landscape',
    description: '京海市扫黑除恶行动持续深入，安欣与高启强之间的终极较量在大银幕上震撼上演。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
    duration: '145分钟',
    tags: ['剧情', '犯罪', '悬疑'],
    updateDate: '2026-06-10',
    featured: false,
    content: '京海市扫黑除恶行动持续深入，安欣与高启强之间的终极较量在大银幕上震撼上演。二十年的恩怨纠葛，正邪之间的最终对决，在更加宏大的叙事格局中展开...',
  },
  {
    id: 'movie-12',
    title: '熊出没·逆转时空2',
    category: '动画片',
    categorySlug: 'animation',
    year: 2026,
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=colorful%203D%20animated%20Chinese%20movie%20scene%20with%20bears%20in%20futuristic%20time%20travel%20adventure%2C%20bright%20and%20playful%20atmosphere%2C%20vibrant%20colors%2C%20family-friendly%20style&width=800&height=450&seq=movie-12&orientation=landscape',
    description: '光头强和熊大熊二再次踏上时空冒险，这次他们要去往更遥远的未来，阻止一场时空危机。',
    director: '林汇达',
    actors: ['谭笑', '张伟', '张秉君'],
    region: '中国大陆',
    duration: '99分钟',
    tags: ['动画', '冒险', '家庭'],
    updateDate: '2026-06-01',
    featured: false,
    content: '光头强和熊大熊二再次踏上时空冒险，这次他们要去往更遥远的未来，阻止一场时空危机。在穿越不同时代的过程中，他们遇到了各种奇妙的生物和挑战，也收获了珍贵的友谊...',
  },
];